var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lottie-ambient-ani-handler no-flicker",style:({
    top: this.animation.position.top,
    left: this.animation.position.left,
    width: this.animation.width ,
    height: this.animation.height
  }),attrs:{"id":_vm.sectionIdName}},[_c('lottie',{ref:"ambientLottie",staticClass:"lottie-ambient-ani-handler__lottie-wrapper",on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }